import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import '../styles/App.css'
import '../styles/index.css'
import '../styles/dark-theme.css'
import FinancePage from '../pages/FinancePage'
import WellnessPage from '../pages/WellnessPage'
import AITechPage from '../pages/AITechPage'
import Layout from './Layout'
import HomePage from './HomePage'
import ScrollToTop from './ScrollToTop'

const AppContent = () => {
  return (
    <div className="app">
      <a href="#main-content" className="skip-to-content">Skip to main content</a>
      <Layout>
        <main id="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/ai-tech" element={<AITechPage />} />
            <Route path="/finance" element={<FinancePage />} />
            <Route path="/wellness" element={<WellnessPage />} />
          </Routes>
        </main>
      </Layout>
    </div>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  )
}

export default App
